<template>
  <div class="sp-template">
    <div class="h-title">订单管理</div>
    <el-card class="box-card">
      <el-form size="small">
        <el-form-item label="常用产品">
          <el-tag v-for="tag in tags" :key="tag">{{tag}}</el-tag>
        </el-form-item>
        <h2 class="sp-card-title">全部产品</h2>
        <el-form-item label="海派">
          <el-select v-model="value1" multiple placeholder="海派" class="width100" style="width:500px;">
            <el-option v-for="item in seaShipping" :key="item.id" :label="item.nameCN" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="空派">
          <el-select v-model="value2" multiple placeholder="空派" class="width100" style="width:500px;">
            <el-option v-for="item in sirShipping" :key="item.id" :label="item.nameCN" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="铁路">
          <el-select v-model="value3" multiple placeholder="铁路" class="width100" style="width:500px;">
            <el-option v-for="item in railwayShipping" :key="item.id" :label="item.nameCN" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value1: [],
      value2: [],
      value3: [],
      seaShipping: [],
      sirShipping: [],
      railwayShipping: []
    };
  },
  components: {},
  created() {
    setTimeout(() => {
      this.loadChannel();
    }, 800);
  },
  computed: {
    tags() {
      let names = new Array();
      this.value1.forEach((d, i) => {
        this.seaShipping.forEach((dd, ii) => {
          if (dd.id == d) {
            names.push(dd.nameCN);
          }
        });
      });
      this.value2.forEach((d, i) => {
        this.sirShipping.forEach((dd, ii) => {
          if (dd.id == d) {
            names.push(dd.nameCN);
          }
        });
      });
      this.value3.forEach((d, i) => {
        this.railwayShipping.forEach((dd, ii) => {
          if (dd.id == d) {
            names.push(dd.nameCN);
          }
        });
      });
      return names;
    }
  },
  methods: {
    loadChannel() {
      let _this = this;
      this.$request1({
        method: 'GET',
        url: '/channel'
      })
        .then(response => {
          console.log(response);
          if (response.data.data && response.data.data.length > 0) {
            response.data.data.forEach((d, i) => {
              if (d.type == "SEA_SHIPPING") {
                _this.seaShipping.push(d);
              } else if (d.type == "AIR_SHIPPING") {
                _this.sirShipping.push(d);
              } else if (d.type == "RAILWAY_SHIPPING") {
                _this.railwayShipping.push(d);
              }
            });
          } else {
            _this.seaShipping = [];
            _this.sirShipping = [];
            _this.railwayShipping = [];
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>


// WEBPACK FOOTER //
// src/views/usercenter/commonproduct.vue